import { Avatar } from 'src/design/atoms/Avatar';
import { Card } from 'src/design/atoms/Card';
import { Group } from 'src/design/atoms/Group';
import { Text } from 'src/design/atoms/Text';
import { BaseModal } from 'src/design/molecules/BaseModal';
import React from 'react';
import { useAuth } from 'src/hooks/useAuth';
import { CreateButton } from 'src/design/atoms/CreateButton';
import { PostForm } from './components/PostForm';

interface PostCardProps {
  onPostCreated: () => void;
  jobId?: number;
}

export const PostCard: React.FC<PostCardProps> = ({ onPostCreated, jobId }) => {
  const [postOpen, setPostOpen] = React.useState(false);
  const { user } = useAuth();

  const handleClose = () => {
    setPostOpen(false);
  };

  const handleOpen = () => {
    setPostOpen(true);
  };

  if (!user) return null;

  return (
    <>
      <Group justify="center">
        <Card withBorder w="100%">
          <Group justify="center" mb="md">
            <Avatar color="blue" radius="xl">
              {user.firstName.slice(0, 1)}
              {user.lastName.slice(0, 1)}
            </Avatar>
            <Text c="dimmed" size="md">
              What would you like to say, {user.fullName}?
            </Text>
          </Group>
          <Group justify="center">
            <CreateButton onClick={handleOpen}>Add Post</CreateButton>
          </Group>
        </Card>
      </Group>

      <BaseModal
        opened={postOpen}
        onClose={handleClose}
        size="xl"
        title="Create Post"
      >
        <PostForm
          handleClose={handleClose}
          onPostCreated={onPostCreated}
          jobId={jobId}
        />
      </BaseModal>
    </>
  );
};
